import { getMarket } from '../i18n';

export const resolveRouteRetailer = () => {
  const { marketCode } = getMarket();
  switch (marketCode) {
    case 'NO':
      return '/forhandler';
    default:
      return '/aterforsaljare';
  }
};
